import { useQuery } from "@apollo/client/react"; import React, { useState, useEffect, useMemo, useCallback } from "react";

import { Grid } from '@mui/material';
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';
import CalculadoraESAS from './components/CalculadoraESAS';
import { obtenerDataImagen } from '../../../../actions/ImagenAction';
import { TextInput } from '../../../../components/textInput/TextInput';
import toast from "react-hot-toast";

const ESCALA_DOLOR_SI_ID = 342;

export const StepCuidadosPaliativos2 = ({
  selectedPrograms,
  setDataSubmissionCallback,
  updateFormData,
  esAdulto,
  fullFormDataRI
}) => {
  const [cuidadosPaliativos, setCuidadosPaliativos] = useState(fullFormDataRI?.cuidadosPaliativos2 ?? {});
  const [combosRI, setCombosRI] = useState();

  const handleSubmit = () => {
    if (cuidadosPaliativos.idComboRIValorPedEscalaDolor === ESCALA_DOLOR_SI_ID &&
      !cuidadosPaliativos.pedFLACCR &&
      !cuidadosPaliativos.pedGustaveRoussy &&
      !cuidadosPaliativos.pedFPSR &&
      !cuidadosPaliativos.escalaNumericaDolor) {
      return toast.error('Debe completar el menos una de las escalas.');
    }
    updateFormData('cuidadosPaliativos2', cuidadosPaliativos, validatedinputsGroups.flatMap((x) => x.inputs));
  };

  const handleChange = (name, value) => {
    setCuidadosPaliativos((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const handleChangeImage = (name, value) => {
    obtenerDataImagen(value).then((image) => {
      handleChange(name,
        {
          contentType: image?.tipo,
          archivo: image?.data,
          extension: image?.extension,
          titulo: image?.nombre
        }
      );
    });
  };

  const onDeleteImage = (name) => {
    handleChange(name, null);
  };

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const validatedinputsGroups = useMemo(() => {
    const updatedRequired = structuredClone(inputsGroups).map((group) => ({
      ...group,
      inputs: group.inputs.map((input) => {
        if (!!input.comboName && !!combosRI) {
          input.options = combosRI[input.name];
        }
        if (input.esPediatrico && esAdulto) {
          input.required = false;
        }
        switch (input.name) {
          case "videodeglucionAdjunto":
            if (!cuidadosPaliativos.videodeglucion)
              onDeleteImage(input.name);
            return {
              ...input,
              hidden: !cuidadosPaliativos?.videodeglucion,
              required: !!cuidadosPaliativos?.videodeglucion
            };
          case 'aduESAS':
            return {
              ...input,
              required: fullFormDataRI?.datosGenerales2?.enfermedadOncologica && esAdulto,
              disabled: !fullFormDataRI?.datosGenerales2?.enfermedadOncologica || !esAdulto
            };
          case 'resultadoAduESAS':
            return {
              ...input,
              required: cuidadosPaliativos?.aduESAS
            };
          case 'resultadoPedGMFS':
            if (!cuidadosPaliativos.pedGMFS) {
              handleChange(input.name);
            }
            return {
              ...input,
              disabled: !cuidadosPaliativos?.pedGMFS,
              required: cuidadosPaliativos.pedGMFS
            };
          case 'pedFLACCR':
          case 'pedGustaveRoussy':
          case 'pedFPSR':
          case 'escalaNumericaDolor':
            input.required = cuidadosPaliativos?.idComboRIValorPedEscalaDolor === ESCALA_DOLOR_SI_ID;
            return input;

          case 'resultadoEscalaNumericaDolor':
            input.disabled = !cuidadosPaliativos?.escalaNumericaDolor;
            input.required = cuidadosPaliativos?.escalaNumericaDolor;
            if (input.disabled) handleChange(input.name);
            return input;

          case 'resultadoPedFLACCR':
            input.disabled = !cuidadosPaliativos?.pedFLACCR;
            input.required = cuidadosPaliativos.pedFLACCR;
            if (input.disabled) handleChange(input.name);
            return input;
          case 'resultadoPedGustaveRoussy':
            input.disabled = !cuidadosPaliativos?.pedGustaveRoussy;
            input.required = cuidadosPaliativos.pedGustaveRoussy;
            if (input.disabled) handleChange(input.name);
            return input;
          case 'idComboRIValorPedEscalaDolor':
            return {
              ...input,
              options: input.options?.map((o) => ({ label: o.displayName, value: o.id }))
            };
          case 'resultadoPedFPSR':
            input.disabled = !cuidadosPaliativos?.pedFPSR;
            input.required = cuidadosPaliativos?.pedFPSR;
            if (input.disabled) handleChange(input.name);
            return input;
          default:
            return input;
        }
      })
    }));
    return updatedRequired;
  }, [
    combosRI,
    selectedPrograms,
    cuidadosPaliativos?.idComboRIValorPedEscalaDolor,
    cuidadosPaliativos?.aduESAS,
    cuidadosPaliativos?.escalaNumericaDolor,
    cuidadosPaliativos?.pedGMFS,
    cuidadosPaliativos?.pedFLACCR,
    cuidadosPaliativos?.pedGustaveRoussy,
    cuidadosPaliativos?.videodeglucion,
    cuidadosPaliativos?.pedFPSR,
    fullFormDataRI?.datosGenerales2?.enfermedadOncologica,
    esAdulto]
  );


  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [cuidadosPaliativos, setDataSubmissionCallback, validatedinputsGroups]);

  useEffect(() => {
    if (cuidadosPaliativos.idComboRIValorPedEscalaDolor !== ESCALA_DOLOR_SI_ID) {
      setCuidadosPaliativos((prevDatos) => ({
        ...prevDatos,
        pedFLACCR: false,
        resultadoPedFLACCR: null,
        pedGustaveRoussy: false,
        resultadoPedGustaveRoussy: null,
        pedFPSR: false,
        resultadoPedFPSR: null,
        escalaNumericaDolor: false,
        resultadoEscalaNumericaDolor: null
      }));
    }
  }, [cuidadosPaliativos.idComboRIValorPedEscalaDolor]);

  return (
    <div>
      {validatedinputsGroups.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className='step-form-section-title'>{group.groupName}</label>
          <Grid
            container>
            {group.inputs.
              filter((input) => !input.hidden).
              filter((input) => !(input.esPediatrico && esAdulto)).
              filter((input) => !(cuidadosPaliativos.idComboRIValorPedEscalaDolor !== ESCALA_DOLOR_SI_ID && input.grupoEscalaDolor)).
              map((input) => {
                return (
                  <React.Fragment key={`${group.groupName}-${input.name}`}>
                    {input.name !== 'aduESAS' && input.name !== 'resultadoAduESAS' ?

                      <RenderInputByTypeMobile
                        grided
                        row
                        handleChange={input.type === 'file' ? handleChangeImage : handleChange}
                        handleDelete={() => onDeleteImage(input.name)}
                        input={input}
                        value={cuidadosPaliativos[input.name]} /> :


                      input.name === 'aduESAS' && fullFormDataRI?.datosGenerales2?.enfermedadOncologica && esAdulto ?

                        <RenderInputByTypeMobile
                          key={`${group.groupName}-${input.name}`}
                          grided
                          row
                          handleChange={input.type === 'file' ? handleChangeImage : handleChange}
                          handleDelete={() => onDeleteImage(input.name)}
                          input={input}
                          value={cuidadosPaliativos[input.name]} /> :


                        input.name === 'resultadoAduESAS' && fullFormDataRI?.datosGenerales2?.enfermedadOncologica && esAdulto && (
                          <CalculadoraESAS
                            variant="esasRI"
                            handleChange={input.type === 'file' ? handleChangeImage : handleChange}
                            handleDelete={() => onDeleteImage(input.name)}
                            input={input}
                            prevResult={cuidadosPaliativos[input.name]}
                            data={cuidadosPaliativos}
                          />
                        )}
                  </React.Fragment>);

              })}
          </Grid>
        </div>
      )
      }
    </div>);

};

const inputsGroups = [
  {
    groupName: 'Examen Fisico',
    inputs: [
      {
        displayName: 'Tension Arterial',
        name: 'tensionArterial',
        type: 'string',
        required: true
      },
      {
        displayName: 'Frec. Cardiaca (L/min)',
        name: 'frecCardiaca',
        type: 'float',
        required: true
      },
      {
        displayName: 'Frec. Respiratoria (R/min)',
        name: 'frecRespiratoria',
        type: 'float',
        required: true
      },
      {
        displayName: 'Temperatura',
        name: 'temperatura',
        type: 'float',
        required: true
      },
      {
        displayName: 'Piel/mucosas/faneras',
        name: 'pielMucosasFaneras',
        type: 'string',
        required: true
      },
      {
        displayName: 'SNC',
        name: 'sNC',
        type: 'string',
        required: true
      },
      {
        displayName: 'CV',
        name: 'cV',
        type: 'string',
        required: true
      },
      {
        displayName: 'Respiratorio',
        name: 'respiratorio',
        type: 'string',
        required: true
      },
      {
        displayName: 'Digestivo',
        name: 'digestivo',
        type: 'string',
        required: true
      },
      {
        name: "videodeglucion",
        displayName: "Videodeglución",
        type: "boolean",
        required: true,
        lightTitle: true
      },
      {
        name: "videodeglucionAdjunto",
        displayName: "Informe de Videodeglución",
        type: "file"
      },
      {
        displayName: 'Otros',
        name: 'otros',
        type: 'string',
        required: true
      },
      {
        displayName: 'Sonda vesical',
        name: 'sondaVesical',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Catéter',
        name: 'cateter',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Sonda nasogástrica',
        name: 'sondaNasogastrica',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Requiere Soporte Nutricional',
        name: 'soporteNutricional',
        options: [
          { value: true, label: "SI" },
          { value: false, label: "NO Corresponde" }],

        type: 'boolean',
        required: true
      },
      {
        displayName: 'ESAS',
        name: 'aduESAS',
        options: [
          { value: true, label: "SI" },
          { value: false, label: "NO Corresponde" }],

        type: 'multiple_boolean',
        required: true
      },
      {
        displayName: 'Resultado ESAS',
        name: 'resultadoAduESAS',
        type: 'float',
        required: true
      },
      {
        displayName: 'Escala LANSKY',
        name: 'idComboRIValorPedLANSKY',
        comboName: 'ESCALA DE LANSKY ',
        type: 'select',
        esPediatrico: true,
        required: false
      },
      {
        displayName: 'ESCALA GMFS',
        name: 'pedGMFS',
        options: [
          { value: true, label: "SI" },
          { value: false, label: "NO Corresponde" }],

        type: 'multiple_boolean',
        esPediatrico: true,
        required: false
      },
      {
        displayName: 'Resultado GMFS',
        name: 'resultadoPedGMFS',
        comboName: 'ESCALA GMFS (Sistema de clasificación de función motora gruesa): para pacientes con encefalopatía crónica/parálisis cerebral',
        type: 'select',
        esPediatrico: true,
        required: true
      },
      {
        displayName: 'Escala de Dolor',
        name: 'idComboRIValorPedEscalaDolor',
        comboName: 'Escala de Dolor',
        type: 'multiple_boolean',
        esPediatrico: true,
        required: true
      },
      {
        displayName: 'Escala FLACC-R',
        name: 'pedFLACCR',
        options: [
          { value: true, label: "SI" },
          { value: false, label: "NO Corresponde" }],

        type: 'multiple_boolean',
        esPediatrico: true,
        grupoEscalaDolor: true,
        required: true
      },
      {
        displayName: 'Resultado (FLACC-R)',
        name: 'resultadoPedFLACCR',
        type: 'int',
        esPediatrico: true,
        grupoEscalaDolor: true,
        min: 0,
        max: 10,
        required: false
      },
      {
        displayName: 'Escala de Gustave-Roussy',
        name: 'pedGustaveRoussy',
        options: [
          { value: true, label: "SI" },
          { value: false, label: "NO Corresponde" }],

        type: 'multiple_boolean',
        esPediatrico: true,
        grupoEscalaDolor: true,
        required: true
      },
      {
        displayName: 'Resultado (Gustave-Roussy)',
        name: 'resultadoPedGustaveRoussy',
        type: 'int',
        esPediatrico: true,
        grupoEscalaDolor: true,
        min: 0,
        max: 10,
        required: true
      },
      {
        displayName: 'Escala FPS-R',
        name: 'pedFPSR',
        options: [
          { value: true, label: "SI" },
          { value: false, label: "NO Corresponde" }],

        type: 'multiple_boolean',
        esPediatrico: true,
        grupoEscalaDolor: true,
        required: true
      },
      {
        displayName: 'Resultado (FPS-R)',
        name: 'resultadoPedFPSR',
        type: 'multiple_boolean',
        esPediatrico: true,
        grupoEscalaDolor: true,
        options: [
          { value: 0, label: "0" },
          { value: 2, label: "2" },
          { value: 4, label: "4" },
          { value: 6, label: "6" },
          { value: 8, label: "8" },
          { value: 10, label: "10" }],

        required: true
      },
      {
        displayName: 'Escala numérica de Dolor',
        name: 'escalaNumericaDolor',
        options: [
          { value: true, label: "SI" },
          { value: false, label: "NO Corresponde" }],

        type: 'multiple_boolean',
        esPediatrico: true,
        grupoEscalaDolor: true,
        required: true
      },
      {
        displayName: 'Resultado numérico de Dolor',
        name: 'resultadoEscalaNumericaDolor',
        type: 'int',
        min: 0,
        max: 10,
        esPediatrico: true,
        grupoEscalaDolor: true,
        required: true
      }]

  }];